import { Navigate } from "react-router-dom";
import { useAuth } from "../context/useAuth";

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isLoggedIn, isAdmin, isLoading } = useAuth();

  // While auth state is being initialized, don't redirect — allow AuthContext to finish.
  if (isLoading) return null;

  if (!isLoggedIn) {
    // or redirect to login, or show some "please login" message
    return <Navigate to="/" replace />;
  }

  if (!isAdmin) {
    // or show "Access denied"
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
